import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { CropDetailFacade } from './crop-detail.facade';

@Component({
  selector: 'ts-crop-detail',
  templateUrl: './crop-detail.component.html',
  styleUrls: ['./crop-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CropDetailFacade],
  standalone: false,
})
export class CropDetailComponent {
  @Input() public overlay = false;
  @Input() public editingEnabled = true;
  @Input() public detailsVisible = true;

  public readonly focusedRoiId$ = this.facade.focusedRoiId$;
  public readonly tileSource$ = this.facade.tileSource$;
  public readonly hspan$ = this.facade.hspan$;
  public readonly rois$ = this.facade.rois$;
  public readonly changes$ = this.facade.changes$;
  public readonly options$ = this.facade.options$;
  public readonly selectedOverlayIds$ = this.facade.selectedOverlayIds$;
  public readonly roiOverlays$ = this.facade.roiOverlays$;
  public readonly roiSizeTiles$ = this.facade.focusedRoiSizeTiles$;

  constructor(private readonly facade: CropDetailFacade) {}

  get centerPoint() {
    return this.facade.centerPoint;
  }
  set centerPoint(value: { x: number; y: number }) {
    this.facade.centerPoint = value;
  }

  get zoomLevel() {
    return this.facade.zoomLevel;
  }
  set zoomLevel(value: number) {
    this.facade.zoomLevel = value;
  }

  get multiselectionEnabled() {
    return this.facade.multiselectionEnabled;
  }
  set multiselectionEnabled(value: boolean) {
    this.facade.multiselectionEnabled = value;
  }

  get dragSelectionEnabled() {
    return this.facade.dragSelectionEnabled;
  }
  set dragSelectionEnabled(value: boolean) {
    this.facade.dragSelectionEnabled = value;
  }

  get viewerMode() {
    return this.facade.viewerMode;
  }

  public formatPercentage(percentage: number): string {
    return `${(percentage * 100).toFixed(1)}%`;
  }

  public onRegionChange(event: PageEvent, selectedOverlayIds: Set<string>): void {
    const focusedRoiId = Array.from(selectedOverlayIds).at(event.pageIndex);
    if (!focusedRoiId) return;
    this.facade.setFocusedRoi(focusedRoiId);
  }

  public revertRoiChanges(roiId: string): void {
    this.facade.revertRoiChanges(roiId);
  }

  public filterByRoiIds(roiIds: string[]): void {
    this.facade.filterByRoiIds(roiIds);
  }
}
